module.exports = __webpack_public_path__ + "img/joe-gym-banner.d4086934.jpg";